import React, { Component } from 'react';
import logo from '../img/logo@3x.png'
import {
    TOGGLE_SETTING_SUCCESS, TOGGLE_SHARE_SUCCESS, TOGGLE_LISTS_SUCCESS, TOGGLE_LIST_HEADER_SUCCESS, TOGGLE_HISTORY_SUCCESS
} from '../actionTypes'
import {connect} from "react-redux";
import {toggleDropBox, toggleHistory} from "../actions";
import {getSumSavedNotification, snapshotToArray} from "../selectors";
import Icon from '@material-ui/core/Icon';
import {conditionHistoryTime} from "../functions/snippets";


const Header = ({ title, toggleDropBox, toggleHistory, type, savedListsNotification, user, history }) => {
    const sum = getSumSavedNotification(savedListsNotification);
    const notific = conditionHistoryTime(history, user)

    const handleToggleHistory = () => {
        toggleHistory()

        /*let firstElement = document.querySelector('.comment__element_first-new')
        let parent = document.querySelector('.comment__content_history')
        let commentNewHint = document.querySelector('.comment__new-hint')
        if(commentNewHint){
            //removeElements( document.querySelectorAll(".comment__new-hint") );
        }
        if(firstElement){
            setTimeout(() => {
                parent.scrollTo(0, firstElement.offsetTop - 120);
                //console.log(firstElement.offsetTop - 120)

            },30)


           /!* var div = document.createElement("div");
            div.className = 'comment__new-hint'
            div.innerHTML = 'Unread'
            firstElement.appendChild(div)*!/
        }else{
            console.log(parent.offsetHeight)
            parent.scrollTo(0, parent.scrollHeight);
        }*/
    }

    const listPageRender = (
        <header className="header">
            <div className="content-center">
                <div className="header-content">
                    <div className="logo">
                        <a href="/" className="logo__link">
                            <img src={logo} alt="" className="logo__img" />
                        </a>
                    </div>
                    <div className="list-title">{ title }</div>


                    <div className="nav-wrap">
                        <div className="list-header-btn list-header-btn_open">
                            <button onClick={() => toggleDropBox(TOGGLE_LIST_HEADER_SUCCESS)}>
                               <Icon>more_horiz</Icon>
                            </button>
                        </div>
                        <div className="nav" onClick={() => toggleDropBox(TOGGLE_SETTING_SUCCESS)}>
                            <i className="nav__icon icon-setting"></i>
                            <div className="nav__hint">Settings</div>
                        </div>

                        <div className="nav" onClick={() => toggleDropBox(TOGGLE_SHARE_SUCCESS)}>
                            <i className="nav__icon icon-share"></i>
                            <div className="nav__hint">Share</div>
                        </div>

                        <div className="nav" onClick={() => toggleDropBox(TOGGLE_LISTS_SUCCESS)}>
                            <i className="nav__icon icon-lists"></i>
                            <div className="nav__hint">Lists
                            </div>
                            {
                                sum > 0 && <span className="history__notification"> +{ sum }</span>
                            }
                        </div>

                        <div className="nav" onClick={handleToggleHistory}>
                            <Icon>notifications</Icon>
                            <div className="nav__hint">
                            </div>
                                {
                                    notific > 0 && <span className="history__notification"> +{ notific }</span>
                                }
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )

    const mainPageRender = (
        <header className="header header_main-page">
            <div className="content-center">
                <div className="header-content">
                    <div className="logo">
                        <a href="/" className="logo__link">
                            <img src={logo} alt="" className="logo__img" />
                        </a>
                    </div>

                    <div className="nav-wrap">
                        <div className="nav" onClick={() => toggleDropBox(TOGGLE_SETTING_SUCCESS)}>
                            <i className="nav__icon icon-setting"></i>
                            <div className="nav__hint">Settings</div>
                        </div>
                        <div className="nav" onClick={() => toggleDropBox(TOGGLE_LISTS_SUCCESS)}>
                            <i className="nav__icon icon-lists"></i>
                            <div className="nav__hint">Lists
                            </div>
                            {
                                sum > 0 && <span className="history__notification"> +{ sum }</span>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )

    const defaultRender = 'хеадер';



    switch(type) {
        case 'listPage' :
            return listPageRender
            break
        case 'mainPage' :
            return mainPageRender
            break
        default:
            return defaultRender
    }


}


const mapStateToProps = state => ({
    title: state.title,
    user: state.user,
    history: state.history,
    savedListsNotification: state.savedListsNotification,
})
const mapDispatchToProps = {
    toggleDropBox,
    toggleHistory
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);


// WEBPACK FOOTER //
// ./src/components/Header.js